export default __webpack_public_path__ + "static/media/Image11.362cfed2.png";